export const Dictionary = {
  __generic_api_failure: "Algo salió mal.",
  __generic_api_error: "No se puede atender su solicitud ahora.",
  __invalid_token:
    "Su solicitud no se puede completar, el token no es válido. Es posible que el token de seguridad haya caducado o ya se haya utilizado.",
  __generic_api_403: "No tienes permiso para realizar esta acción.",
  __you_are_offline: "No estás conectado a Internet.",
  __coming_soon:
    "Esta funcionalidad se encuentra en desarrollo y estará disponible muy pronto.",
};
